<template>
    <div class="flight_search_item_wrappper">
        <div class="flight_search_items">
            <div class="multi_city_flight_lists w-100" data-bs-toggle="collapse"
                :data-bs-target="'#collapseExample' + item.id" aria-expanded="false" aria-controls="collapseExample">
                <div class="flight_multis_area_wrapper">
                    <div class="flight_search_left">
                        <div class="flight_logo relative">
                            <div :class="'flight-image i-' + item.itineraries[type].segments[0].carrierCode.toString().toLowerCase()"
                                v-tooltip.top="result.airlines[item.itineraries[type].segments[0].carrierCode][$i18n.locale]">
                            </div>
                            <small class="trusted-partner">
                                {{ item.officeId == 'RUHS228ZQ' ? $t('Traveler Club') : $t('Almosafer') }}
                            </small>
                        </div>
                        <div class="flight_search_destination">
                            <h3>
                                {{ item.itineraries[type].segments[0].departure.iataCode }}
                            </h3>
                            <p class="time">
                                {{
                                    getFormattedTime(item.itineraries[type].segments[0].departure.at)
                                }}
                            </p>
                            <p class="date">
                                {{
                                    getFormattedDate(item.itineraries[type].segments[0].departure.at)
                                }}
                            </p>
                            <h6>{{ item.itineraries[type].segments[0].departure.airportName }}
                            </h6>
                        </div>
                    </div>
                    <div class="flight_right_arrow">
                        <img :src="require(`@/assets/img/icons/right_arrow.png`)" alt="img" />
                        <h6>
                            {{
                                item.itineraries[type].segments.length - 1 == 0 ?
                                    $t('Direct Flight')
                                    : item.itineraries[type].segments.length - 1 + ' ' + $t('Stop')
                            }}
                        </h6>
                        <p>{{ convertDuration(item.itineraries[type].duration) }}</p>
                    </div>
                    <div class="flight_search_middel">
                        <div class="flight_search_destination">
                            <h3>
                                {{ item.itineraries[type].segments[item.itineraries[type].segments.length
                                    - 1].arrival.iataCode }}

                            </h3>
                            <p class="time">
                                {{
                                    getFormattedTime(item.itineraries[type].segments[item.itineraries[type].segments.length
                                        - 1].arrival.at) }}
                            </p>
                            <p class="date">
                                {{
                                    getFormattedDate(item.itineraries[type].segments[item.itineraries[type].segments.length
                                        -
                                        1].arrival.at) }}
                            </p>
                            <h6>
                                {{
                                    item.itineraries[type].segments[item.itineraries[type].segments.length
                                        - 1].arrival.airportName }}
                            </h6>
                        </div>
                    </div>
                </div>
                <h6 v-if="!is_selected" class="show" data-bs-toggle="collapse"
                    :data-bs-target="'#collapseExample' + item.id" aria-expanded="false"
                    aria-controls="collapseExample">{{ $t('Show more')
                    }}<i class="fas fa-chevron-down"></i></h6>
                <div v-if="!is_selected" class="dduKua">
                    <span>
                        {{ $t('seats') }} : {{ item.numberOfBookableSeats }}
                    </span>
                </div>
            </div>
            <div v-if="!is_selected" class="flight_search_right">
                <h3 class="price">
                    {{ get_total_price_with_markup(item.travelerPricings).toFixed(2) }}
                    <span class="primary-color">{{ $t('SAR') }}</span>
                </h3>
                <a @click="select_flight" class="btn btn_theme btn_sm select-flight">
                    <span>
                        {{
                            $t('Select Flight')
                        }}
                    </span>
                </a>
            </div>
            <div v-else class="flight_search_right">
                <a @click="change_flight" class="btn btn_theme btn_sm change-flight">
                    <span>{{ $t('Change') }}</span>
                </a>
            </div>
        </div>
        <div v-if="!is_selected" class="flight_policy_refund collapse" :id="'collapseExample' + item.id">
            <div v-for='(segment, index) in item.itineraries[type].segments' class="flight_show_down_wrapper">
                <div class="flight-shoe_dow_item d-flex w-100">
                    <div class="airline-details mt-2">
                        <div class="img">
                            <div
                                :class="'flight-image  flight-image-sm i-' + segment.carrierCode.toString().toLowerCase()">
                            </div>
                        </div>
                        <span class="airlineName fw-500">{{
                            result.airlines[segment.carrierCode][$i18n.locale] }}
                            &nbsp;
                            {{ segment.carrierCode }}{{ segment.number }}
                        </span>
                    </div>
                    <div class="flight_inner_show_component w-70">
                        <div class="flight_det_wrapper">
                            <div class="flight_det">
                                <div class="code_time">
                                    <span class="code">
                                        {{ segment.departure.iataCode }}
                                    </span>
                                    <span class="time">
                                        {{ getFormattedTime(segment.departure.at) }}
                                    </span>
                                </div>
                                <p class="airport">
                                    {{ segment.departure.airportName }}
                                </p>
                                <p class="date">
                                    {{ getFormattedDate(segment.departure.at) }}
                                </p>
                            </div>
                        </div>
                        <div class="flight_duration">
                            <div class="arrow_right"></div>
                            <span>
                                {{ convertDuration(segment.duration) }}
                            </span>
                        </div>
                        <div class="flight_det_wrapper">
                            <div class="flight_det">
                                <div class="code_time">
                                    <span class="code">
                                        {{ segment.arrival.iataCode }}
                                    </span>
                                    <span class="time">
                                        {{ getFormattedTime(segment.arrival.at) }}
                                    </span>
                                </div>
                                <p class="airport">
                                    {{ segment.arrival.airportName }}
                                </p>
                                <p class="date">
                                    {{ getFormattedDate(segment.arrival.at) }}
                                </p>
                            </div>
                        </div>
                        <div>
                            {{ $t('Number of bags') }} :
                            {{
                                getFareDetailsBySegmentId(item.travelerPricings, segment.id) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Tooltip from 'lightvue/tooltip';
import { formatDate } from '@/utils/dateUtils';
import { formatTime, convertDuration } from '@/utils/timeUtils';
import { getPriceWithMarkup, getTotalPriceWithMarkup } from '@/utils/priceUtils';
export default {
    name: "FlightItem",
    directives: {
        tooltip: Tooltip,
    },
    props: [
        'item',
        'type',
        'result',
        'is_selected',
    ],
    data() {
        return {
            need_approval: false
        }
    },
    methods: {
        getFormattedDate(dateString) {
            const { day, month, year } = formatDate(dateString);
            return `${day} ${this.$t(month)} ${year}`;
        },
        getFormattedTime(timeString) {
            return formatTime(timeString);
        },
        convertDuration(duration) {
            return convertDuration(duration, this.$i18n.locale);
        },
        getFareDetailsBySegmentId(travelerPricings, segmentId) {
            var travelerPricing = travelerPricings[0].fareDetailsBySegment.filter(item => {
                return item.segmentId == segmentId;
            });
            if (travelerPricing.length) {
                travelerPricing = travelerPricing[0];
                if (travelerPricing.includedCheckedBags.quantity != null) {
                    return `${travelerPricing.includedCheckedBags.quantity}`;
                } else {
                    return `${travelerPricing.includedCheckedBags.weight} ${travelerPricing.includedCheckedBags.weightUnit}`;
                }
            }
            return 0;
        },
        get_price_with_markup(ticketPrice) {
            return getPriceWithMarkup(ticketPrice, 500000000);
        },
        get_total_price_with_markup(travelerPricings) {
            return getTotalPriceWithMarkup(travelerPricings, 500000000);
        },
        select_flight() {
            this.need_approval = false;
            this.$emit('select_flight', this.item, this.type, this.need_approval);
        },
        change_flight() {
            this.$emit('change_flight', this.type == 0 ? 'departure' : 'arrival');
        }
    },
    mounted() {
        this.need_approval = false;
    }
};
</script>